var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 14.6673H9.99992C13.3333 14.6673 14.6666 13.334 14.6666 10.0007V6.00065C14.6666 2.66732 13.3333 1.33398 9.99992 1.33398H5.99992C2.66659 1.33398 1.33325 2.66732 1.33325 6.00065V10.0007C1.33325 13.334 2.66659 14.6673 5.99992 14.6673Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 6.66667C6.73646 6.66667 7.33341 6.06971 7.33341 5.33333C7.33341 4.59695 6.73646 4 6.00008 4C5.2637 4 4.66675 4.59695 4.66675 5.33333C4.66675 6.06971 5.2637 6.66667 6.00008 6.66667Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78003 12.633L5.0667 10.4264C5.59336 10.073 6.35336 10.113 6.8267 10.5197L7.0467 10.713C7.5667 11.1597 8.4067 11.1597 8.9267 10.713L11.7 8.33305C12.22 7.88638 13.06 7.88638 13.58 8.33305L14.6667 9.26638",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.14c9b035a87538d95c6da1ec913efbf5.svg";
export { ForwardRef as ReactComponent };